import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Card, CardActions, CardContent, CardHeader, Grid, Divider,
	colors, List, ListItem, ListItemText, Typography, IconButton,
	Input, Paper, Tooltip
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { AddComment, GetComments } from '../../../../actions/SiteTrackerActions';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(1),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	paper: {
		flexGrow: 1,
		padding: theme.spacing(0.5, 2),
	},
	input: {
		width: '100%',
	},
}));

const SiteTrackerComments = (props) => {
	const { className, tableId, title, comments, disabled, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const [commentValue, setCommentValue] = useState('');
	const userId = useSelector(state => state.session.user.id);

	const _handleCommentInputChange = (event) => {
		let comment = event.target.value;
		comment = comment.trim();
		if (comment.length >= 0) {
			setCommentValue(event.target.value);
		}
	};

	const _postComment = () => {
		dispatch(AddComment(userId, tableId, title, commentValue));
		setCommentValue('');
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title={title || 'Comments history'} />
			<Divider />
			<CardContent style={{ maxHeight: '15vh', overflowY: 'scroll', paddingTop: 0, paddingBottom: 0 }}>
				<Grid container spacing={4}>
					<Grid item md={12} xs={12}>
						{comments && (
							<List sx={{ padding: 0 }}>
								{comments.length > 0 ? comments.map(comment => (
									<React.Fragment key={comment.id}>
										<ListItem alignItems="flex-start" sx={{ padding: 0 }}>
											<ListItemText
												primary={(
													<Typography
														component="span"
														color="textPrimary"
														style={{ fontWeight: 'bold' }}
													>
														{`${comment.userName} at ${moment(comment.creationTimestamp).format('DD-MM-YYYY HH:mm:ss').toString()} - `}
													</Typography>
												)}
												secondary={(
													<Typography
														component="span"
														variant="body2"
														color="textPrimary"
													// style={{ marginLeft: '5%' }}
													>
														{comment.comment}
													</Typography>
												)}
											/>
										</ListItem>
										<Divider component="li" />
									</React.Fragment>
								)) : (
									<>
										<ListItem alignItems="flex-start">
											<ListItemText
												secondary={(
													<>
														<Typography
															component="span"
															variant="body2"
															color="textPrimary"
															style={{ marginLeft: '5%' }}
														>
															No comments added
														</Typography>
													</>
												)}
											/>
										</ListItem>
									</>
								)}
							</List>
						)}
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Paper className={classes.paper} elevation={1}>
					<Input
						value={commentValue}
						className={classes.input}
						disableUnderline
						onChange={_handleCommentInputChange}
						placeholder="Type a comment"
					/>
				</Paper>
				<Tooltip title="Post">
					<span>
						<IconButton
							color={commentValue.length > 0 ? 'primary' : 'default'}
							disabled={!commentValue.length > 0 || disabled}
							onClick={_postComment}
						>
							<SendIcon />
						</IconButton>
					</span>
				</Tooltip>
			</CardActions>
		</Card>
	);
};

SiteTrackerComments.propTypes = {
	className: PropTypes.object,
	tableId: PropTypes.number,
	title: PropTypes.string,
	comments: PropTypes.array,
};

export default SiteTrackerComments;
